// Dialog4.js

import {
    axios,
    useImperativeHandle, forwardRef, useRef, useContext, useState, useEffect,
    useSelector, useDispatch,
    useLocation, useNavigate, Link,
    AppTheme,
    mui, reducer, component, useShared,  
    replaceTabVerseListNewItem, setRead, getYearOfBirthList, localizedDateTime, verseRangeChineseName, sortResultList, canPushNewEntry, Highlight, resetSelectedAll, getBookChapterVerseChineseName, getChapterChineseName, getBookChapterChineseName, getTabLabel,
    VERSION, COUNTRY_LIST, MAX_LENGTH_SEARCH_STRING, MAX_LENGTH_NOTE_CONTENT, MAX_LENGTH_NOTE_TITLE, SPACE, API_BASE_URL, MAX_LENGTH_NON_SEARCH_STRING1, MAX_LENGTH_NON_SEARCH_STRING2,
    homeContext, searchContext, noteContext,
} from '../Utilities/sharedHeader';

export default function Dialog4({setOpen4}){

    const { Slider, Snackbar, styled, grey, Grid, Chip, Divider, Tab, Tabs, Box, Accordion, AccordionSummary, AccordionDetails, ListItemIcon, List, ListItem, ListItemText, TextField, IconButton, InputBase, Paper, Alert, Select, FormControl, FormControlLabel, FormLabel, FormGroup, MenuItem, Container, Typography, ButtonGroup, Button, Stack, Fab, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Radio, RadioGroup, AppBar, Toolbar, Table, TableContainer, TableBody, TableRow, TableCell, CardMedia, CardContent, CssBaseline, FormHelperText, Switch, Card, CheckIcon, ClearIcon, DeleteIcon, CloseIcon, ExpandMoreIcon, VisibilityOutlinedIcon, KeyboardArrowUpIcon, KeyboardDoubleArrowUpIcon, HistoryIcon, StickyNote2Icon, NoteAddIcon, SearchIcon, DescriptionIcon, EditDocumentIcon, ImportContactsIcon, WestIcon, EastIcon, HomeIcon, PersonIcon, LogoutIcon, PlagiarismIcon, DeviceThermostatIcon, FileCopyIcon, LocalOfferIcon, InfoIcon } = mui;
    const { setButtonTextDialog4, setButtonText, setDialogTitle, setBookReadLogToBeCleared, setCallerConfirmationDialog, setCaller4NoteBookmarkList, setNoteSearchString, setConfirmedNoteSearchString, setNoteSearchStringClearButton, setShowRemainingNoteSearch, setSearchCriteriaListItem2, setSearchResultVerseList2, setPageNumberNoteSearch, setVerseListItem2, setNoteSearchStringPlaceHolder, reset4NoteSearch, setTabVerseListNew, reset4SignIn, setTitleToBeDeleted, reset4ConfirmationDialog, reset4GoToTopButtonVisible, reset4NoteBookmarkList, reset4Dialog4, reset4NoteBookmarkVerseList, reset4ChipArray, reset4verseLabelArrows4Result, reset4Switch1, reset4Dialog2, reset4Search, reset4Verse, reset4Chapter, reset4Book, reset4Home, setGoToTopButtonVisible, setVerseListItem, setNonSearchString1PlaceHolder, setNonSearchString2PlaceHolder, setSearchStringPlaceHolder, setSearchString, setShowLeftArrowVerseSearch, setShowRightArrowVerseSearch, setShowfabContentVerseSearch, setShowLeftArrowNote, setShowRightArrowNote, setShowfabContentNote, setShowLeftArrowNoteSearch, setShowRightArrowNoteSearch, setShowfabContentNoteSearch, setSearchCriteriaListItem, setPageNumberVerseSearch, setOpenConfirmationDialog, setOpen3, setConfirmedTabNumber, setOpen2, setPageNumberNote, setDetails, setLengthIndicator4Details, setLengthIndicator4Title, setLoading, setHistoryList, setHistoryListItemSelected, setHistoryBookChapter, setNoteBookmarkList, setNoteBookmarkListBookChapterVerse, setConfirmedSearchString, setNonSearchString1, setNonSearchString2, setSearchStringClearButton, setNonSearchStringClearButton, setSearchScopeList, setSearchScopeListItemSelected, setChipData, setShowRemaining, setSearchResultVerseList, setSearchHttpPostData, setBookChapterList, setBookChapterListItemSelected, setOpen1, setBookListItemSelected, setSearchCriteria, setLoading4Home, setUserListItem, setVerseReadLogList4Book, setSearchTabNumber, setBookChapter, setBookList, setTitle, setTitleClearButton, setBook4Accordion1, setChapter4Accordion1, setVerse4Accordion1, setBookChapter2, setBookChapterList2, setVerseList4Accordion1, setNoteBookmarkVerseList, setNoteBookmarkListItemToBeDeleted, setNoteBookmarkListItemToBeChanged, setTab4AddChange, setViewArea, setCredential, setCircularProgressText, setEmailExisted, setUsernameExisted, setLastNameOverMaxLength, setFirstNameOverMaxLength, reset4Profile } = reducer;
    const { SignUpEmailSent, Profile4System, Profile4Personal, History, AddChangeNote, FullFormatVerse, Book, Stack1, NoteVerseList, Chapter, Dialog1, Dialog2, Dialog3, Dialog4, Tab1, Navbar, VerseSearch, Verse, NoteBookmarkList, NoteBookmarkListItem, VerseLabelArrows4Result, ConfirmationDialog, Accordion1, ChipArray, SearchResult, ForgotPassword, ClipLoader1, VerseLabelArrows, Switch1, Selection, Profile, UserListItem } = component;  
    const { postUserListItem, bookRead, deleteVerseReadLogList, getNoteBookmarkList3, deleteLogListItem, getToken, postLogListItem, postPutSearchCriteriaListItem, deleteVerseReadLogListItem, postPutVerseReadLogListItem, postHistoryListItem, getHasNoteVersesAll, getSearchResultVerseList, getSearchCriteriaListItem, postNoteBookmarkListItem, putNoteBookmarkListItem2, putNoteBookmarkListItem1, getNoteBookmarkList, getVerseReadLogList4Book, getSearchScopeList, getVerseList4Accordion1, getUserListItem, getVerseList, getBookList, getHistoryList, putUserListItem } = useShared();

    const dispatch = useDispatch(); // dispatch(
    const title = useSelector((state) => state.dialog4.title);
    const lengthIndicator4Title = useSelector((state) => state.dialog4.lengthIndicator4Title);
    const details = useSelector((state) => state.dialog4.details);
    const lengthIndicator4Details = useSelector((state) => state.dialog4.lengthIndicator4Details);
    const tabVerseListNew = useSelector((state) => state.verse.tabVerseListNew);
    const noteBookmarkListItemToBeChanged = useSelector((state) => state.dialog4.noteBookmarkListItemToBeChanged);
    const tab4AddChange = useSelector((state) => state.dialog4.tab4AddChange);
    const buttonTextDialog4 = useSelector((state) => state.dialog4.buttonTextDialog4);

    const handleOnChangeTab = (e, newTabNumber) => {
        dispatch(setTab4AddChange(newTabNumber));
    }

    // const handleOnClickClear = () => {
    //     dispatch(setOpen4(false));
    // }

    const handleOnClickCheck = async () => {
        if (noteBookmarkListItemToBeChanged != null) {
            await putNoteBookmarkListItem1('Dialog4');
            getHasNoteVersesAll(tabVerseListNew, 'Dialog4');
        } else {
            await postNoteBookmarkListItem('Dialog4');
            const list = resetSelectedAll(tabVerseListNew);
            getHasNoteVersesAll(list, 'Dialog4');            
        }                
        setOpen4(false);
    }

    const handleOnChangeDetails = (e) => {        
        let value = e.target.value;
        let maxLength = MAX_LENGTH_NOTE_CONTENT;
        let currentLength = value.length;
        if (currentLength <= maxLength) {
            dispatch(setDetails(value));
            let indicator = `${currentLength} / ${maxLength}`;
            dispatch(setLengthIndicator4Details(indicator));
        }
    }

    const handleOnChangeTitle = (e) => {        
        let value = e.target.value;
        let maxLength = MAX_LENGTH_NOTE_TITLE;
        let currentLength = value.length;
        if (currentLength <= maxLength) {
            dispatch(setTitle(value));
            let indicator = `${currentLength} / ${maxLength}`;
            dispatch(setLengthIndicator4Title(indicator));
        }
    }

    const initializeNoteVerseList = () => {

        let list = [];

        tabVerseListNew.forEach((tabVerseListNewItem, tabNumber) => {
            tabVerseListNewItem.verses.forEach((item, index) => {
                if (item.selected) {
                    const exists = list.find(listItem => listItem.book === tabVerseListNewItem.book && listItem.chapter === tabVerseListNewItem.chapter && listItem.verse === index+1);
                    if (!exists) list.push({ book: tabVerseListNewItem.book, chapter: tabVerseListNewItem.chapter, verse: index+1, details: item.details });
                }
            });
        });        

        list.sort((a, b) => {
            return (
                a.book - b.book ||
                a.chapter - b.chapter ||
                a.verse - b.verse
            );
        });       
        dispatch(setNoteBookmarkVerseList(list)); 
    }

    useEffect(() => {
        dispatch(setLengthIndicator4Title(`${title.length} / ${MAX_LENGTH_NOTE_TITLE}`));
    }, [title]);    

    useEffect(() => {
        dispatch(setLengthIndicator4Details(`${details.length} / ${MAX_LENGTH_NOTE_CONTENT}`));
    }, [details]);

    useEffect(() => {

        //dispatch(setLengthIndicator4Title(`${title.length} / ${MAX_LENGTH_NOTE_TITLE}`));

        dispatch(setBook4Accordion1(0)); // for selection in Accordion1.js
        dispatch(setChapter4Accordion1(0)); // for selection in Accordion1.js
        dispatch(setVerse4Accordion1(0)); // for selection in Accordion1.js
        dispatch(setBookChapter2({book: 0, chapter: 0})); // for selection in Accordion1.js

        //dispatch(setLengthIndicator4Details(`${details.length} / ${MAX_LENGTH_NOTE_CONTENT}`));

        if (noteBookmarkListItemToBeChanged != null) {
            dispatch(setTitle(noteBookmarkListItemToBeChanged.title));
            dispatch(setDetails(noteBookmarkListItemToBeChanged.details));     
            dispatch(setNoteBookmarkVerseList(noteBookmarkListItemToBeChanged.noteBookmarkVerseList)); 
            dispatch(setButtonTextDialog4('更新'))
            //dispatch(setNoteBookmarkVerseList([{book: 1, chapter: 1, verse: 5}])); 
        } else {
            dispatch(setTitle(''));
            dispatch(setDetails('')); 
            dispatch(setNoteBookmarkVerseList([]));
            dispatch(setButtonTextDialog4('新增'))
            initializeNoteVerseList();                  
        }

    }, []);

    return (

        <div>

            <Tabs value={tab4AddChange} onChange={handleOnChangeTab}>
                <Tab label={'相關經文'}/>
                <Tab label={'標題內容'}/>
            </Tabs>

            <div style={{ display: tab4AddChange === 0 ? 'block' : 'none' }}>
                <Grid container spacing={1} padding={1} sx={{mt: 1}}>
                    <Grid size={12}>
                        <NoteVerseList />
                    </Grid>                    
                </Grid>
            </div>

            <div style={{ display: tab4AddChange === 1 ? 'block' : 'none' }}>
                <Grid container spacing={1} padding={1} sx={{mt: 1}}>

                    <Grid size={12}>
                        <Typography gutterBottom variant="h6" component="div" sx={{ color: theme => theme.palette.grey[500] }}>
                            標題
                        </Typography>
                        <InputBase
                            // sx={{ ml: 1, flex: 1 }}
                            sx={{
                                // backgroundColor: 'white',
                                border: '1px solid', // Set border width and style
                                borderColor: theme => theme.palette.grey[500], // Use theme-based color
                                borderRadius: 1, // Set rounded corners
                                padding: 1, // Add padding inside the input
                                width: '100%', // Make it responsive
                            }}                        
                            //MAX_LENGTH_NOTE_TITLE
                            placeholder={`輸入最多${MAX_LENGTH_NOTE_TITLE}字`}
                            value={title}
                            onChange={handleOnChangeTitle}
                            fullWidth
                        />                    
                    </Grid>  

                    <Grid size={12} sx={{marginTop: -1}}>
                        <Typography
                            sx={{ width: '100%', textAlign: 'right', fontSize: 12, color: theme => theme.palette.grey[500] }}
                        >
                        {lengthIndicator4Title}
                        </Typography>
                    </Grid>            

                    <Grid size={12}>
                        <Typography gutterBottom variant="h6" component="div" sx={{ color: theme => theme.palette.grey[500] }}>
                            內容
                        </Typography>
                        <InputBase
                            multiline
                            rows={12}
                            sx={{
                                border: '1px solid', // Set border width and style
                                borderColor: theme => theme.palette.grey[500], // Use theme-based color
                                borderRadius: 1, // Set rounded corners
                                padding: 1, // Add padding inside the input
                                width: '100%', // Make it responsive
                            }}
                            placeholder={`輸入最多${MAX_LENGTH_NOTE_CONTENT}字`}
                            value={details}
                            onChange={handleOnChangeDetails}
                            fullWidth
                        />  

                    </Grid>     

                    <Grid size={12} sx={{marginTop: -1}}>
                        <Typography
                            sx={{ width: '100%', textAlign: 'right', fontSize: 12, color: theme => theme.palette.grey[500] }}
                        >
                        {lengthIndicator4Details}
                        </Typography>
                    </Grid>

                    <Grid size={12}>

                        {/* <IconButton
                            sx={{
                                borderRadius: 1,
                                bgcolor: 'primary.main',
                                '&:hover': { bgcolor: 'primary.main' },
                                width: '100%',
                            }}
                            onClick={handleOnClickCheck}
                        >
                            <CheckIcon sx={{ color: 'white' }} />
                        </IconButton>  */}

                        <Button
                            sx={{
                                borderRadius: 1,
                                bgcolor: 'primary.main',
                                color: 'white',
                                '&:hover': { bgcolor: 'primary.dark' }, // Adjust hover color if needed
                                width: '100%',
                            }}
                            onClick={handleOnClickCheck}
                        >
                            {buttonTextDialog4}
                        </Button>                        

                    </Grid>           

                </Grid>
            </div>
        
        </div>
    )
}